<template>
  <div class="d-flex jc-end m-b-2">
    <div
        class="d-flex ai-center jc-center LIST"
        :class="{'ACTIVE' : selectedViewOption === list}"
        @click="handleSelection(list)">
      <div class="m-l-2 m-r-1 ">{{ list }}</div>
      <div class="d-flex ai-center m-r-2">
        <svg
            width="37"
            height="36"
            viewBox="0 0 37 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
          <path
              fill="currentColor"
              d="M5 19.5H8V16.5H5V19.5ZM5 25.5H8V22.5H5V25.5ZM5 13.5H8V10.5H5V13.5ZM11 19.5H32V16.5H11V19.5ZM11 25.5H32V22.5H11V25.5ZM11 10.5V13.5H32V10.5H11Z"/>
        </svg>
      </div>
    </div>
    <div
        class="d-flex ai-center MONTH"
        :class="{'ACTIVE' : selectedViewOption === month}"
        @click="handleSelection(month)">
      <div class="m-l-2 m-r-1">{{ month }}</div>
      <div class="d-flex ai-center m-r-3">
        <svg width="24" height="24" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" fill="none"/>
          <path
              d="M22.5 3.375H21.375V1.125H19.125V3.375H7.875V1.125H5.625V3.375H4.5C3.2625 3.375 2.25 4.3875 2.25 5.625V23.625C2.25 24.8625 3.2625 25.875 4.5 25.875H22.5C23.7375 25.875 24.75 24.8625 24.75 23.625V5.625C24.75 4.3875 23.7375 3.375 22.5 3.375ZM22.5 23.625H4.5V9H22.5V23.625Z"
              fill="currentColor"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>

import Storage from '@homeservices/tool-kit/storage/local-storage';
import { VIEW_OPTIONS } from '@/constants/schedule-view-selections';

const REMEMBER_VIEW_KEY = 'PR_REMEMBER_SCHEDULE_VIEW';
export default {
  name: 'view-selection',
  VIEW_OPTIONS,
  data () {
    return {
      month: VIEW_OPTIONS.MONTH,
      list: VIEW_OPTIONS.LIST,
      selectedViewOption: '',
    };
  },
  computed: {
    displayText () {
      return this.selectedViewOption;
    },
  },
  mounted () {
    this.selectedViewOption = Storage.get(REMEMBER_VIEW_KEY) || VIEW_OPTIONS.LIST;
  },
  methods: {
    handleSelection (selection) {
      Storage.remove(REMEMBER_VIEW_KEY);
      Storage.set(REMEMBER_VIEW_KEY, selection);
      this.$emit('view-change', selection);
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .LIST {
    height: 30px;
    border: solid 1px $color-depot;
    border-radius: 13px 0 0 13px;
    background-color: white;
    color: $color-depot;
  }
  .MONTH {
    height: 30px;
    border: solid 1px $color-depot;
    border-radius: 0 13px 13px 0;
    background-color: white;
    color: $color-depot;
  }
  .ACTIVE {
    background-color: $color-depot;
    color: white;
  }
</style>
